import { render, staticRenderFns } from "./ApprovedReview.vue?vue&type=template&id=014e9c54&scoped=true"
import script from "./ApprovedReview.vue?vue&type=script&lang=js"
export * from "./ApprovedReview.vue?vue&type=script&lang=js"
import style0 from "./ApprovedReview.vue?vue&type=style&index=0&id=014e9c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e9c54",
  null
  
)

export default component.exports